<template>
  <div class="my-4">
    <div class="flex items-center gap-2 mb-2">
      <label>salid:</label>
      <input
        type="number"
        v-model="salid"
        min="1"
        class="border text-black rounded px-2 py-1 w-24"
        :disabled="readonly"
      />
      <Button size="small" @click="copyRegister" severity="primary" label="Copy Register" />
      <Button size="small" @click="copyFtd" label="Copy FTD" />
      <Button v-if="depositTemplate" size="small" @click="copyDeposit" severity="secondary" label="Copy Deposit" />
    </div>
    <pre class="text-md p-2 rounded mb-2 overflow-x-auto whitespace-pre">
Register -
{{ registerUrl }}

FTD -
{{ ftdUrl }}
<template v-if="depositTemplate">
Deposit -
{{ depositUrl }}
</template>
    </pre>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  defaultSalid:     { type: Number,  default: 34 },
  registerTemplate: { type: String,  required: true },
  ftdTemplate:      { type: String,  required: true },
  depositTemplate:  { type: String,  default: null },
  readonly:         { type: Boolean, default: false },
});

const salid = ref(props.defaultSalid);

const registerUrl = computed(() => props.registerTemplate.replace('{salid}', salid.value));
const ftdUrl = computed(() => props.ftdTemplate.replace('{salid}', salid.value));
const depositUrl = computed(() => props.depositTemplate ? props.depositTemplate.replace('{salid}', salid.value) : '');

function copyToClipboard(text) { navigator.clipboard.writeText(text); }
function copyRegister() { copyToClipboard(registerUrl.value); }
function copyFtd() { copyToClipboard(ftdUrl.value); }
function copyDeposit() { copyToClipboard(depositUrl.value); }
</script>
